var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell",class:{ 'push-right': _vm.pushRight, 'text-overflow': _vm.textOverflow },style:(_vm.flexChildStyle)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }